export const SEARCH_STATE_CHANGED = "SEARCH_STATE_CHANGED";
export const HITS_LOADED = "HITS_LOADED";
export const OPERATOR_UPDATED = "OPERATOR_UPDATED";
export const HIDE_SKIPPED_CHANGED = "HIDE_SKIPPED_CHANGED";
export const HIDE_REJECTED_CHANGED = "HIDE_REJECTED_CHANGED";
export const HIDE_MATCHED_CHANGED = "HIDE_MATCHED_CHANGED";
export const GEOGRAPHICAL_REGION_CHANGED = "GEOGRAPHICAL_REGION_CHANGED";
export const LOCATION_FILTER_CHANGED = "LOCATION_FILTER_CHANGED";
export const COUNTRY_REFINEMENT_CHANGED = "COUNTRY_REFINEMENT_CHANGED";
export const DISJUNCTIVE_FACETS_CHANGED = "DISJUNCTIVE_FACETS_CHANGED";
export const SKILL_SEARCH_STATE_CHANGED = "SKILL_SEARCH_STATE_CHANGED";
export const LOADING_AI_SEARCH_CHANGED = "LOADING_AI_SEARCH_CHANGED";
export const RE_RANK_HITS_FOR_JOB_CHANGED = "RE_RANK_HITS_FOR_JOB_CHANGED";
export const READY_FOR_SEARCH_CHANGED = "READY_FOR_SEARCH_CHANGED";
export const PAGE_IS_LOADED_CHANGED = "PAGE_IS_LOADED_CHANGED";
